import { useLocalObservable } from 'mobx-react'
import React, { createContext, PropsWithChildren } from 'react'
import { SessionService } from '../../../services/session'
import SessionData from '../../../services/session/SessionData'

export type SignatureText = {
	fullName: string
	initials: string
	email: string
}

export type SignatureInput = {
	signatureData: {
		viewSignatureValue?: string | undefined
		drawSignatureValue?: string | undefined
	}
} & SignatureText

function createSignatureStore(signatureInput?: SignatureInput): SignatureInput {
	let fullName = ''
	let initials = ''
	let email = ''

	const sessionService = SessionService.getInstance()
	const idToken = SessionData.idToken.tokenPayload!

	if (sessionService.isSignedInUser) {
		if (idToken.given_name && idToken.family_name) {
			fullName = idToken.given_name + ' ' + idToken.family_name
			initials = idToken.given_name.charAt(0) + idToken.family_name.charAt(0)
		}
		if (idToken.email) email = idToken.email
	}

	return (
		signatureInput ?? {
			fullName: fullName,
			initials: initials,
			email: email,
			signatureData: {
				viewSignatureValue: undefined,
				drawSignatureValue: undefined,
			},
		}
	)
}

type SignatureStoreType = ReturnType<typeof createSignatureStore>
const signatureStoreContext = createContext<SignatureStoreType | undefined>(
	undefined,
)

type SignatureStoreProviderProps = PropsWithChildren<{
	signatureInput?: SignatureInput
}>

export const SignatureStoreProvider: React.FC<SignatureStoreProviderProps> = ({
	children,
	signatureInput,
}: SignatureStoreProviderProps) => {
	const store = useLocalObservable(() => createSignatureStore(signatureInput))

	return (
		<signatureStoreContext.Provider value={store}>
			{' '}
			{children}{' '}
		</signatureStoreContext.Provider>
	)
}

export const useSignatureStore = () => {
	const context = React.useContext(signatureStoreContext)
	if (!context) throw 'store could not be found'
	return context
}
